import { render, staticRenderFns } from "./ProductInfoEditor.vue?vue&type=template&id=7651d988&scoped=true&"
import script from "./ProductInfoEditor.vue?vue&type=script&lang=js&"
export * from "./ProductInfoEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7651d988",
  null
  
)

export default component.exports